import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  NewBreezeUpModal,
  SaleBreezeUpModel,
} from 'src/app/models/sales/sale-settings.model';
import { DateParserFormatter } from 'src/app/utils/helper/date-parser-formatter';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';

@Component({
  selector: 'app-sale-breeze-date-modal',
  templateUrl: './sale-breeze-date-modal.component.html',
  styleUrls: ['./sale-breeze-date-modal.component.scss'],
})
export class SaleBreezeDateModalComponent
  extends BaseUnsubscribeComponent
  implements OnInit
{
  @Input() public data: any;

  @ViewChild('saleDateTime') saleDateTime: ElementRef;
  @ViewChild('breezeDateTime') breezeDateTime: ElementRef;
  @ViewChild('xrayScopeTaken') xrayScopeTaken: ElementRef;
  @ViewChild('xrayScopeVisible') xrayScopeVisible: ElementRef;

  public saleBreezeUpForm: FormGroup;
  public submitted = false;
  currentBook: number = null;
  currentSessions: NewBreezeUpModal[] = [];
  currentSessionNumber: number = null;
  currentFirstHip: number = null;
  currentLastHip: number = null;
  hipRange: number[] = [];
  maxHips: number[] = [];
  public dateFormat: any;

  constructor(
    public readonly modal: NgbActiveModal,
    private readonly formBuilder: FormBuilder,
    @Inject(DateParserFormatter)
    public dateParserFormatter: DateParserFormatter
  ) {
    super();
  }

  public formSubmit(): void {
    this.submitted = true;

    if (this.saleBreezeUpForm.invalid) {
      return;
    }

    let formData = this.saleBreezeUpForm;
    this.modal.close(formData);
  }

  public ngOnInit(): void {
    if (this.data.breezeUp) {
      this.saleBreezeUpForm = SaleBreezeUpModel.asFormGroup(
        this.data.breezeUp.value
      );
      this.loadDataForEditing(this.data.breezeUp.value);
    } else {
      this.saleBreezeUpForm = SaleBreezeUpModel.newFormGroup();
    }

    this.dateFormat = this.dateParserFormatter.getMomentDateTimeFormat();
  }

  loadSessions($event: any): void {
    const bookNumber = parseInt($event.target.value);
    if (this.currentBook !== bookNumber) {
      this.currentBook = bookNumber;
      this.currentSessions = this.data.books.find(
        (b: any) => b.bookNumber === this.currentBook
      )?.sessions;
      this.saleBreezeUpForm.patchValue({ sessionNumber: null });
      this.currentSessionNumber = null;
    }
  }

  loadHips($event: any): void {
    const sessionNumber = parseInt($event.target.value);
    if (this.currentSessionNumber !== sessionNumber) {
      const session = this.data.books
        .find((b: any) => b.bookNumber === this.currentBook)
        ?.sessions.find((s: any) => s.sessionNumber === sessionNumber);
      this.renderHips(session.firstHip, session.lastHip);

      // Clear all data.
      this.saleBreezeUpForm.patchValue({
        minLotNumber: null,
        maxLotNumber: null,
        saleDateTime: session.saleDate,
      });

      this.loadMaxHips({ target: { value: this.currentFirstHip } });
    }
  }

  loadMaxHips($event: any): void {
    const selectedMinHip = parseInt($event.target.value);
    this.maxHips = this.hipRange.filter((hip) => hip >= selectedMinHip);
  }

  renderHips(firstHip: number, lastHip: number): void {
    this.currentFirstHip = firstHip;
    this.currentLastHip = lastHip;

    let firstHipRange = firstHip;

    const hiprange = [];
    do {
      hiprange.push(firstHipRange);
      firstHipRange++;
    } while (firstHipRange <= this.currentLastHip);

    this.hipRange = hiprange;
  }

  loadDataForEditing(breezeUp: SaleBreezeUpModel): void {
    this.loadSessions({ target: { value: breezeUp.bookNumber } });
    this.saleBreezeUpForm.patchValue({ sessionNumber: breezeUp.sessionNumber });
    this.loadHips({ target: { value: breezeUp.sessionNumber } });

    this.saleBreezeUpForm.patchValue({
      minLotNumber: breezeUp.minLotNumber,
      maxLotNumber: breezeUp.maxLotNumber,
      saleDateTime: breezeUp.saleDateTime,
    });
    this.renderHips(this.currentFirstHip, this.currentLastHip);
    this.loadMaxHips({ target: { value: breezeUp.minLotNumber } });
  }

  onSelectDate($event: any, field: string) {
    this.saleBreezeUpForm.patchValue({
      [field]: this.dateParserFormatter.getISODate($event.start),
    });

    console.log(this.saleBreezeUpForm.value);
  }

  openDatePicker(dateElement: ElementRef): void {
    dateElement.nativeElement.click();
  }
}
